// To test components
import React from "react";
import { Row } from "reactstrap";
import { Colxx } from "../../components/common/CustomBootstrap";
// import { CustomMapClusterer } from "../../../components/common/CustomMap";
// import { usePosition } from "../../../components/common/getLocation";

function Components() {
  // const { position } = usePosition();
  // console.log("asd" && position);
  // const center = { lat: -28.024, lng: 140.887 };

  // const center = { lat: 27.70744430532618, lng: 85.31723860419925 };

  // const locations = [
  //   { lat: -31.56391, lng: 147.154312 },
  //   { lat: -33.718234, lng: 150.363181 },
  //   { lat: -33.727111, lng: 150.371124 }
  // ];

  return (
    <>
      <Row>
        <Colxx md="6">
          <div style={{ height: "700px" }}>
            {/* <CustomMapClusterer center={center} locations={locations} /> */}
          </div>
          {/* <OfferCard /> */}
        </Colxx>
      </Row>
      <Row>
        <Colxx md="4">{/* <CategoryCard /> */}</Colxx>
      </Row>
      <Row>
        <Colxx md="4">{/* <FeatureOfferCard /> */}</Colxx>
      </Row>
    </>
  );
}

export default Components;
